// extracted by mini-css-extract-plugin
module.exports = {"tileWrapper":"_677c3ed","visuallySimilarWrapper":"_6c3baef9","favoritesWrapper":"_8f282ede","folderIconWrapper":"_c4e78704","heartIconWrapper":"_6e00be58"};